// // src/App.js
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Navbar from "./component/navbar";
import Search from "./component/search";
import Login from "./component/login";
import PairItUp from "./component/pairItUp";
import ProtectedRoute from "./component/ProtectedRoute";
import { Container } from "@mui/material";
import { AuthProvider } from "./context/AuthContext";
import AdminDashboard from "./admin";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route
            path="/*"
            element={
              <>
                <Navbar />
                <Container sx={{ mt: 4 }}>
                  <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/" element={<Navigate to="/search" />} />
                    <Route
                      path="/search"
                      element={
                        <ProtectedRoute>
                          <Search />
                        </ProtectedRoute>
                      }
                    />
                    <Route path="/pair-it-up" element={<ProtectedRoute><PairItUp /></ProtectedRoute>} />
                  </Routes>
                </Container>
              </>
            }
          />

          {/* Route without Navbar */}
          <Route
            path="/admin/*"
            element={
              <ProtectedRoute requireAdmin={true}>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
